import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { Project } from "app/interfaces/project";
import { ProjectsService } from "app/services/projects.service";

@Component({
	selector: "app-automotive-ind",
	templateUrl: "./automotive-ind.component.html",
	styleUrls: ["./automotive-ind.component.scss"],
})
export class AutomotiveIndComponent implements OnInit, OnChanges {
	automotiveProjs: Project[] = [];

	@Input() keywords : string = null;
	constructor(
		private projectsService: ProjectsService
	) {}

	ngOnInit() {
		this.getProjects();
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.getProjects();
	}

	getProjects(): void {
		this.automotiveProjs = this.projectsService.getAutomotive(this.keywords);
	}

	getImage(a : any){
		return a.attach[0].src || a.attach[0];
	}
}
